import { extendSchema } from 'govbr.frontend.policy/helpers';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  addContent: { id: 'Add content', defaultMessage: 'Add content' },
  hideImage: {
    id: 'Hide Image',
    defaultMessage: 'Hide Image',
  },
  buttonLabel: { id: 'Button label', defaultMessage: 'Button label' },
  buttonLink: { id: 'Link URL', defaultMessage: 'Link URL' },
  contents: { id: 'Contents', defaultMessage: 'Contents' },
  contentsDescription: {
    id: 'contentsDescription',
    defaultMessage: 'Choose content for listing.',
  },
  content: { id: 'Content', defaultMessage: 'Content' },
  title: { id: 'Title', defaultMessage: 'Title' },
  source: { id: 'Source', defaultMessage: 'Source' },
  subtitle: { id: 'Subtitle', defaultMessage: 'Subtitle' },
  headerAndFooter: { id: 'Header / Footer', defaultMessage: 'Header / Footer' },
  buttonLabelDescription: {
    id: 'For the button to be displayed, you must fill in its text and the Link URL.',
    defaultMessage:
      'For the button to be displayed, you must fill in its text and the Link URL.',
  },
});

export const contentSchema = ({ intl }) => {
  return {
    title: intl.formatMessage(messages.content),
    addMessage: intl.formatMessage(messages.addContent),
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.content),
        fields: ['source'],
      },
    ],
    properties: {
      source: {
        title: intl.formatMessage(messages.source),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['UID'],
        allowExternals: false,
      },
    },
    required: [],
  };
};

export const baseListingSelectionSchema = ({ intl }) => {
  return {
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.headerAndFooter),
        fields: ['hideImage'],
      },
      {
        id: 'headerAndFooter',
        title: intl.formatMessage(messages.headerAndFooter),
        fields: ['title', 'subtitle', 'buttonLabel', 'buttonLink'],
      },
    ],
    properties: {
      hideImage: {
        title: intl.formatMessage(messages.hideImage),
        required: false,
        default: false,
        type: 'boolean',
      },
      title: { title: intl.formatMessage(messages.title) },
      subtitle: {
        title: intl.formatMessage(messages.subtitle),
      },
      buttonLink: {
        title: intl.formatMessage(messages.buttonLink),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['Title', 'Description'],
        allowExternals: true,
      },
      buttonLabel: {
        title: intl.formatMessage(messages.buttonLabel),
        description: intl.formatMessage(messages.buttonLabelDescription),
      },
    },
    required: ['contents'],
  };
};

export const listingSelectionSchema = ({ intl }) => {
  const fields = ['contents'];
  const properties = {
    contents: {
      widget: 'object_list',
      title: intl.formatMessage(messages.contents),
      description: intl.formatMessage(messages.contentsDescription),
      schema: contentSchema,
    },
  };
  return extendSchema(baseListingSelectionSchema, { intl }, fields, properties);
};
